import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ErpSyncFailuresPage } from '@pages/erp-sync-failures';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/failures')({
  component: ErpSyncFailuresRoute,
});

function ErpSyncFailuresRoute() {
  const { locale } = Route.useParams();
  const navigate = useNavigate();

  return (
    <ErpSyncFailuresPage
      onOpenEvidence={(runId) => {
        void navigate({
          to: '/$locale/erp-sync/evidence',
          params: { locale },
          search: { focus: `run:${runId}` },
        });
      }}
    />
  );
}
